import { Spin } from 'antd';
import { getMemberByIdV2 } from 'apis/ums';
import { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import MemberBaseInfo from './base-info';
import MemberOrderList from './order-list';
import MemberPointHistory from './point-history';
import MemberOperateHistory from './operate-history';
import MemberLoginLog from './login-log';
import MemberAddressList from './address-list';
import MemberMailHistory from './mail-history';
import RecyclingConsignmentHistory from './recycling-consignment-history';
import { UnwrapPromise } from 'types/base';
import LayoutFloatButton from 'components/layout-float-button';
import MemberBaseInfo2 from './base-info-2';
import MemberCartList from './cart-list';
import MemberCollectionList from './collection-list';

const MemberView = () => {
  const { id } = useParams<{ id: string }>();
  const [member, setMember] =
    useState<UnwrapPromise<ReturnType<typeof getMemberByIdV2>>>();

  const getMemberInfo = useCallback(() => {
    if (!id) return;
    return getMemberByIdV2(Number(id)).then((res) => {
      setMember(res);
    });
  }, [id]);

  useEffect(() => {
    getMemberInfo();
  }, [getMemberInfo]);

  if (!member) {
    return <Spin />;
  }

  return (
    <div className="space-y-4">
      <MemberBaseInfo member={member} onSaveSuccess={getMemberInfo} />
      <MemberBaseInfo2 member={member} onRefreshSuccess={getMemberInfo} />
      <MemberAddressList memberId={member.id} />
      <MemberOrderList memberId={member.id} />
      <MemberCartList memberId={member.id} />
      <MemberCollectionList memberId={member.id} />
      <MemberPointHistory memberId={member.id} />
      <MemberOperateHistory memberId={member.id} />
      <MemberLoginLog memberId={member.id} />
      <RecyclingConsignmentHistory memberId={member.id} member={member} />
      <MemberMailHistory memberId={member.id} />
      <LayoutFloatButton />
    </div>
  );
};

export default MemberView;
